/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Stems_TitleInputs */



/**
* | output |
* | --- |
* | "Audio Stems" |
*
* @param {Audio_Stems_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_title = /** @type {((inputs?: Audio_Stems_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pistes audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Stems")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tracce audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиодорожки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pistas de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频分轨")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオステム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो स्टेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faixas de áudio")
	return /** @type {LocalizedString} */ ("Audio Stems")
});